import DOMPurify from 'dompurify'

const typesConfig = {
  assignee_group_id: 'Assign to',
  assignee_id: 'Assign to',
  snooze_until: 'Snooze for',
  status: 'Change to',
}

export const getActionTitle = ({ type, label }) => {
  return typesConfig[type] ? `${typesConfig[type]} ${label}` : label
}

export const sanitizeBody = (body, purify = DOMPurify()) => {
  purify.addHook('afterSanitizeAttributes', node => {
    if (node.hasAttribute('style')) {
      const styleAttribute = node.getAttribute('style')
      const newStyle = styleAttribute
        .split(';')
        // Remove color style, because we want to show inherited color for normal text
        // Remove background-color, in case it's set to white, which will make the text invisible
        .filter(
          style =>
            !style.trim().startsWith('color:') &&
            !style.trim().startsWith('background-color:')
        )
        .join(';')
      node.setAttribute('style', newStyle)
    }
  })
  return purify.sanitize(body, { ALLOW_UNKNOWN_PROTOCOLS: true })
}
